var e = /* @__PURE__ */ ((r) => (r.FILE_DOWNLOAD = "file-download", r))(e || {});
export {
  e as DownloadCardIconName
};
//# sourceMappingURL=propsTypes.js.map
